import React from 'react';
import styled from 'styled-components';
import { layout, media } from 'src/components/base';

type BadgeProps = {
  badgeUrl: string;
  awardName: string;
  year: number;
  className?: string;
};

const ProductOfTheYearAwardImg = styled.img`
  display: block;
  z-index: 1;
`;

export const ProductOfTheYearAwardBadge = ({
  awardName,
  badgeUrl,
  year,
  className,
}: BadgeProps) => (
  <ProductOfTheYearAwardImg
    className={className}
    src={badgeUrl}
    alt={`${awardName} ${year}`}
    title={`${awardName} ${year}`}
  />
);

export const GridCardProductOfTheYearAwardBadge = styled(
  ProductOfTheYearAwardBadge
)`
  position: absolute;
  width: 56px;
  top: ${layout.measurements.spacing400};
  right: ${layout.measurements.spacing075};
`;

export const ListCardProductOfTheYearAwardBadge = styled(
  ProductOfTheYearAwardBadge
)`
  position: absolute;
  width: 32px;
  top: ${layout.measurements.spacing400};
  left: ${layout.measurements.spacing100};
`;

export const ProductHeaderProductOfTheYearAwardBadge = styled(
  ProductOfTheYearAwardBadge
)`
  position: absolute;
  width: 40px;
  right: 0;
  top: 0;

  ${media.mediumUp`
    width: 48px;
  `}
`;
